import React, { useMemo, useState } from 'react'
import { IconButton, SwitchBase } from '@instacart/ids-customers'
import { ConfirmIcon, RefundIcon } from '@instacart/ids-core'
import { Input } from '../../../shared-styled-components/SharedStyledComponents'
import { type Datum } from './PublishDataGrid'
import PublishDataGridRow from './PublishDataGridRow'

interface PublishDataGridEditRowProps {
  datum: Datum
  onUpdate: (datum: Datum) => void
  onCancel: () => void
  attributeNameBlacklist: string[]
}

const PublishDataGridEditRow: React.FC<PublishDataGridEditRowProps> = ({
  datum,
  onUpdate,
  onCancel,
  attributeNameBlacklist,
}) => {
  const [updatedDatum, setUpdatedDatum] = useState(datum)
  const anythingChanged = useMemo(
    () =>
      updatedDatum.attributeName !== datum.attributeName ||
      updatedDatum.campField !== datum.campField ||
      updatedDatum.required !== datum.required,
    [updatedDatum, datum]
  )
  const attributeNameInput = (
    <Input
      error={
        updatedDatum.attributeName === '' ||
        attributeNameBlacklist.includes(updatedDatum.attributeName)
      }
      value={updatedDatum.attributeName}
      onChange={(e: any) => setUpdatedDatum({ ...updatedDatum, attributeName: e.target.value })}
    />
  )
  const campFieldInput = (
    <Input
      error={updatedDatum.campField === ''}
      value={updatedDatum.campField}
      onChange={(e: any) => setUpdatedDatum({ ...updatedDatum, campField: e.target.value })}
    />
  )
  const requiredInput = (
    <SwitchBase
      checked={updatedDatum.required}
      onChange={(checked: boolean) => setUpdatedDatum({ ...updatedDatum, required: checked })}
      description="Required"
    />
  )
  const actions = useMemo(
    () => [
      <IconButton icon={RefundIcon} key="cancel" onPress={onCancel} accessibleLabel="Cancel" />,
      <IconButton
        icon={ConfirmIcon}
        key="save"
        onPress={() => onUpdate(updatedDatum)}
        disabled={
          updatedDatum.attributeName === '' ||
          attributeNameBlacklist.includes(updatedDatum.attributeName) ||
          !anythingChanged
        }
        accessibleLabel="Save"
      />,
    ],
    [onUpdate, onCancel, updatedDatum, anythingChanged, attributeNameBlacklist]
  )
  return (
    <PublishDataGridRow
      attributeName={attributeNameInput}
      campField={campFieldInput}
      required={requiredInput}
      actions={actions}
    />
  )
}

export default PublishDataGridEditRow
